import { createSlice } from "@reduxjs/toolkit";

const botResponseSlice = createSlice({
    name: "botResponse",
    initialState: {
        botResponse: '',
        modelCompletion: '',
        suggestedResponses: [],
    },
    reducers: {
        updateBotResponse: (state, action) => {
            const token = action.payload;
            state.botResponse = state.botResponse.concat(token).replace(/\\n/g, '<br/>');
        },
        resetBotResponse: (state) => {
            state.botResponse = ''
            state.modelCompletion = ''
        },
        updateModelCompletion: (state, action) => {
            const token = action.payload;
            state.modelCompletion = state.modelCompletion.concat(token)
        },
        setSuggestedResponses: (state, action) => {
            state.suggestedResponses = action.payload;
        }
    },
});

export const { updateBotResponse, resetBotResponse, updateModelCompletion, setSuggestedResponses } = botResponseSlice.actions;

export default botResponseSlice.reducer;

// export selectBotResponse = (state) => state.botResponse